"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removePii = exports.SenderType = exports.RoomEventType = exports.MessageEventType = void 0;
var MessageEventType;
(function (MessageEventType) {
    MessageEventType["Created"] = "created";
    MessageEventType["Deleted"] = "deleted";
    MessageEventType["Updated"] = "updated";
    MessageEventType["Hide"] = "hide";
    MessageEventType["Saw"] = "saw";
})(MessageEventType = exports.MessageEventType || (exports.MessageEventType = {}));
var RoomEventType;
(function (RoomEventType) {
    RoomEventType["Typing"] = "typing";
    RoomEventType["Snapshot"] = "snapshot";
})(RoomEventType = exports.RoomEventType || (exports.RoomEventType = {}));
var SenderType;
(function (SenderType) {
    SenderType["Customer"] = "Device";
    SenderType["Expert"] = "Technician";
    SenderType["Team"] = "Team";
})(SenderType = exports.SenderType || (exports.SenderType = {}));
exports.removePii = (message) => {
    var _a, _b;
    return ((_b = (_a = message === null || message === void 0 ? void 0 : message.payload) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.text) ? Object.assign(Object.assign({}, message), { payload: Object.assign(Object.assign({}, message.payload), { value: Object.assign(Object.assign({}, message.payload.value), { text: 'reduced' }) }) }) : message;
};
